import React, { useMemo } from 'react';
import { winNumbersColor } from '../../helpers/winNumbersColor';

export const ResultImg = ({ roundData: { number } }) => {

  const winNumbersResult = useMemo(()=>{
    return winNumbersColor(number)
  },[number]);

   return (
    <div className="hash-code-img-wrp">
      <div className={`hash-code-img-inner type-${winNumbersResult.type}`}>
        <p className="hash-code-img-inner-number left">{winNumbersResult.numbers[0]}</p>
        <p className="hash-code-img-inner-number center">{winNumbersResult.numbers[1]}</p>
        <p className="hash-code-img-inner-number right">{winNumbersResult.numbers[2]}</p>
      </div>
    </div>
  );
};
